import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRegisterVerify } from '../Login/api';
import { useTranslation } from 'react-i18next';
import Loader from '../../Loader/buttonLoad';

const Thankyou = (props) => {
    const { id } = useParams()

    const [hide, setHide] = useState(false)
    const navigate=useNavigate()
    const {t} = useTranslation()
    const verifyRegister = useRegisterVerify()
    useEffect(() => {
        userResgisterVerify()
    }, [id])
    const userResgisterVerify = async () => {
        try {
            const res = await verifyRegister.mutateAsync({ id: id })
            if (res?.status) {
                setHide(true)
            }

        } catch (error) {

        }
    }

    return (
        <div className="AuthPg">
            <div className="container">
                {
                    hide ?
                        <div className="row justify-content-center">
                            <div className="col-xl-5 col-lg-8">
                                <div className="AuthBgFrm">
                                    <img src={require('../../assets/images/thankyou.gif')} alt="" className='d-block mx-auto mb-3' width="72px" />
                                    <h3 className="text-center">{t('Thank You!')}</h3>
                                    <p className="text-center">{t('Your Sign-up Process is almost done')}</p>
                                    <div className="form-group">
                                        <button className='btn CmnBtn w-100 h-46' onClick={()=>navigate('/login')}>{t('Sign in')}</button>
                                    </div>
                                </div>
                            </div>
                        </div> : <Loader/>
                }

            </div>
        </div>
    );
}

export default Thankyou;